import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

import pisPasep from '~js/pispasep';

const CPF = require("cpf_cnpj").CPF;
const CNPJ = require("cpf_cnpj").CNPJ;
const cardValidator = require('card-validator');

VeeValidate.Validator.extend('not_zero', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} é obrigatório.`;
    }
  },
  validate(value) {
    return !!parseInt(value.replace(/[\.|,]/g, ''));
  }
});

VeeValidate.Validator.extend('cpf', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve ser um CPF válido.`;
    }
  },
  validate(value) {
    return CPF.isValid(value);
  }
});

VeeValidate.Validator.extend('cnpj', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve ser um CNPJ válido.`;
    }
  },
  validate(value) {
    return CNPJ.isValid(value);
  }
});

VeeValidate.Validator.extend('pispasep', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve ser um PIS/PASEP válido.`;
    }
  },
  validate(value) {
    return pisPasep(value);
  }
});

VeeValidate.Validator.extend('inss', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve ser um INSS válido.`;
    }
  },
  validate(value) {
    return pisPasep(value);
  }
});

VeeValidate.Validator.extend('conta', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve possuir um - separando o dígito verificador.`;
    }
  },
  validate(value) {
    return /-[0-9xX]$/g.test(value);
  }
});

VeeValidate.Validator.extend('inssPisUnico', {
  messages: {
    pt_BR: field => {
      return `O ${field} já está sendo usado por outra pessoa.`;
    }
  },
  validate(value, parametros) {
    let cpf = parametros[0].replace(/ /g, '');
    
    if (value.length !== 14) {
      return true;
    }

    return Vue.http.get(`/api/pessoas/InssPisEmUso/${encodeURIComponent(cpf)}`,{
        params: {
          inssPis : value,
        }
      })
      .then(resultado => {
        return true;
      })
      .catch(erro => {
        if (erro.status === 400) {
          return false;
        } else {
          this.$mensagemErro(erro, 'Erro ao validar Pispasep\INSS');
        }
      });
  }
});

VeeValidate.Validator.extend('senhaigual', {
  messages: {
    pt_BR: field => {
      return `A ${field} não pode ser igual a senha atual.`;
    }
  },
  validate(value, parametros) {
    let senhaatual = parametros[0];
    return (senhaatual !== value);
  }
});

VeeValidate.Validator.extend('nomecompleto', {
  messages: {
    pt_BR: field => {
      return `O ${field} deve composto por nome e sobrenome.`;
    }
  },
  validate(value = "") {
    let nomeArray = value.split(" ");

    nomeArray = nomeArray.filter(x => x.trim().length > 0);

    return (nomeArray.length > 1);
  }
});

VeeValidate.Validator.extend('numerocartao', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve possuir 16 números.`;
    }
  },
  validate(value) {
    return (value.length == 16);
  }
});

VeeValidate.Validator.extend('numerocartaovalido', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve ser um número válido.`;
    }
  },
  validate(value) {
    var numberValidation = cardValidator.number(value);

    return (numberValidation.isValid);
  }
});

VeeValidate.Validator.extend('datacartaovalido', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve ser uma data válida.`;
    }
  },
  validate(value) {
    if (value.length < 7)
      return false;

    const dataValidade = value.split("/");
    let now = new Date

    const mes = parseInt(dataValidade[0]);
    const ano = parseInt(dataValidade[1]);

    if ((mes < 1) || (mes > 12))
      return false;

    if (ano < now.getFullYear())
      return false;

    if (ano == now.getFullYear()) {

      if (mes < now.getMonth() + 1)
        return false;
    }

    return true;
  }
});

VeeValidate.Validator.extend('cvvvalido', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve número válido.`;
    }
  },
  validate(value) {
    const cvvLength = value.length;

    if ((cvvLength < 3) || (cvvLength > 4))
      return false;

    return true
  }
});

VeeValidate.Validator.extend('minimo10', {
  messages: {
    pt_BR: field => {
      return `O campo ${field} deve conter pelo menos 10 caracteres.`;
    }
  },
  validate(value, parametros) {
    return value.length > 10;
  }
});



// WEBPACK FOOTER //
// ./FrontEnd/js/validacoes.js